import { render, staticRenderFns } from "./ValidatedSelection.vue?vue&type=template&id=36df0b50&scoped=true"
import script from "./ValidatedSelection.vue?vue&type=script&lang=js"
export * from "./ValidatedSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df0b50",
  null
  
)

export default component.exports